import GetWidgetReservationsRequestModelBase from '../_generated/modelBases/get-widget-reservations-request-model-base';

export default class GetWidgetReservationsRequestModel extends GetWidgetReservationsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
